export default __webpack_public_path__ + "static/media/group_title.b86a69d8.png";